import { UseQueryResult } from "@tanstack/react-query";
import { KeyboardEventHandler, useCallback, useState } from "react";
import { match } from "ts-pattern";

import { LoadingTable } from "~/components/database/detail/database-content/LoadingTable";
import {
  ColumnPosition,
  Props,
  SortRule,
  buildTabHeadings,
  generateSortedInfoByOrder,
} from "~/components/database/detail/database-content/lib";
import ResponseTable from "~/components/database/detail/database-content/response-table/ResponseTable";
import { VerifiedDbLabel } from "~/extensions/hojokin";
import { DatabaseDetailTableContentQuery } from "~/lib/graphql/client";

const SpDatabaseContent = ({
  form,
  form: { questions },
  responses,
  openItemDetail,
}: Props & { responses: UseQueryResult<DatabaseDetailTableContentQuery> }) => {
  const [sortRule, setSortRule] = useState<SortRule>({
    columnPosition: "rowNumber",
    order: "asc",
  });

  const onTableHeadingClickHandler = useCallback(
    (columnPosition: ColumnPosition) => {
      return () => {
        setSortRule((prevState) => {
          return generateSortedInfoByOrder(prevState, columnPosition);
        });
      };
    },
    []
  );

  const onTableHeadingKeyDownHandler = useCallback(
    (columnPosition: ColumnPosition): KeyboardEventHandler => {
      return (event) => {
        if (event.code === "Enter" || event.code === "Space") {
          setSortRule((prevState) => {
            return generateSortedInfoByOrder(prevState, columnPosition);
          });
        }
      };
    },
    []
  );

  const tabHeadings = buildTabHeadings(
    questions,
    sortRule,
    onTableHeadingClickHandler,
    onTableHeadingKeyDownHandler
  );

  return (
    <div>
      {match(responses)
        .with({ status: "pending" }, () => <LoadingTable />)
        .with({ status: "error" }, (matched) => (
          <div>Error: {matched.error.message}</div>
        ))
        .with({ status: "success" }, (matched) => (
          <ResponseTable
            form={form}
            tabHeadings={tabHeadings}
            sortRule={sortRule}
            responses={matched.data.form.responses}
            openItemDetail={openItemDetail}
          />
        ))
        .exhaustive()}
      <VerifiedDbLabel id={form.id} />
    </div>
  );
};

/**
 * @package
 */
export default SpDatabaseContent;
